export default __webpack_public_path__ + "static/media/17.963e24a3.png";